export default __webpack_public_path__ + "static/media/samandehi-verified.42df37e1.png";